import * as yup from 'yup';

export interface FalabellaConnectorFormValues {
  sellerId: string;
  userId: string;
  apiKey: string;
}

export const falabellaConnectorSchema = yup.object().shape({
  sellerId: yup.string().trim().required('El Seller ID es obligatorio'),
  userId: yup
    .string()
    .trim()
    .required('El User ID es obligatorio')
    .email('El User ID debe ser un correo electrónico válido'),
  apiKey: yup.string().trim().required('El API Key es obligatorio'),
});
